import { render } from "./zendesk.vue?vue&type=template&id=6ab3a7b2&scoped=true"
import script from "./zendesk.vue?vue&type=script&lang=js"
export * from "./zendesk.vue?vue&type=script&lang=js"

import "./zendesk.vue?vue&type=style&index=0&id=6ab3a7b2&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab3a7b2"]])

export default __exports__